/* eslint-disable jsx-a11y/anchor-is-valid */
import {Route, Routes} from 'react-router-dom'
import {RelatorioLayout} from './RelatorioLayout'
import { ReportGenerationPage } from './components/reportGenerationPage'
import { ReportDetailsPage } from './components/reportDetailsPage'
import { Error404 } from '../errors/components/Error404'

const RelatorioPage = () => (
  <Routes>
    <Route element={<RelatorioLayout />}>
      <Route path='geracao/:id' element={<ReportGenerationPage />} />
      <Route path='detalhado/:id' element={<ReportDetailsPage />} />
      <Route index element={<Error404 />} />
    </Route>
  </Routes>
)

export {RelatorioPage}
